import React from "react";
import KenoLogo from "./KenoLogo";

export default (): JSX.Element => {
    return (
        <div className="keno-bonus-logo">
            <KenoLogo />&nbsp;Bonus
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/KenoBonusLogo.tsx